module.exports = __webpack_public_path__ + "img/sfkc.2e35d8cf.png";